'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bill = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Bill, _Component);

  function Bill() {
    (0, _classCallCheck3.default)(this, Bill);
    return (0, _possibleConstructorReturn3.default)(this, (Bill.__proto__ || (0, _getPrototypeOf2.default)(Bill)).apply(this, arguments));
  }

  (0, _createClass3.default)(Bill, [{
    key: 'renderCoupon',
    value: function renderCoupon(item, j, i) {
      var styles = require('./Bill.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.couponContainer, key: 'coupon_' + i + '_' + j },
        _react2.default.createElement(
          'span',
          { className: styles.couponName },
          item.name
        ),
        _react2.default.createElement(
          'span',
          { className: styles.couponPrice },
          item.price
        )
      );
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, i) {
      var _this2 = this;

      var styles = require('./Bill.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.serviceCon, key: 'service_' + i },
        _react2.default.createElement(
          'div',
          { className: styles.serviceBox },
          _react2.default.createElement(
            'span',
            { className: styles.serviceName },
            item.name
          ),
          _react2.default.createElement(
            'span',
            { className: styles.servicePrice },
            item.price
          )
        ),
        !!item.details && item.details.map(function (v, j) {
          return _this2.renderCoupon(v, j, i);
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Bill.scss');
      var _props = this.props,
          data = _props.data,
          onClose = _props.onClose;

      var services = null,
          total = null,
          discountAll = null;
      if (data) {
        services = data.services;
        total = data.total;
        discountAll = data.discountAll;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.boxHead },
          _react2.default.createElement(
            'div',
            { className: styles.closeIcon, onClick: onClose },
            _react2.default.createElement('i', { className: 'fa fa-close' })
          ),
          _react2.default.createElement(
            'label',
            null,
            'Gi\xE1 b\u1EA1n tr\u1EA3'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.totalPrice },
            total !== 0 ? total : total + ' \u0111'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.boxContent },
          _react2.default.createElement(
            'div',
            { className: styles.billTitle },
            _react2.default.createElement(
              'label',
              { className: styles.serviceTitle },
              'D\u1ECBch v\u1EE5'
            ),
            _react2.default.createElement('div', { className: styles.seperateLine }),
            _react2.default.createElement(
              'label',
              { className: styles.priceTitle },
              'S\u1ED1 ti\u1EC1n'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.billServices },
            services && services.map(function (v, i) {
              return _this3.renderItem(v, i, i + 1 === services.length);
            })
          ),
          !!discountAll && _react2.default.createElement(
            'div',
            { className: styles.discountAllBox },
            _react2.default.createElement(
              'span',
              { className: styles.couponText },
              'Khung gi\u1EDD gi\u1EA3m gi\xE1'
            ),
            _react2.default.createElement(
              'span',
              { className: styles.couponText },
              '- ' + discountAll
            )
          )
        )
      );
    }
  }]);
  return Bill;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onClose: _react.PropTypes.func
}, _temp);
exports.default = Bill;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Bill.js
// module id = 1550
// module chunks = 0